import { Expose } from 'class-transformer';

export default class AdminBillingAccountUpdateFormError {
    invoice_due_days: string[] = []
    should_reconcile_invoices: string[] = []
    invoice_late_fee_start_after: string[] = []
    invoice_late_fee_per_job: string[] = []
    should_send_invoice_to_practice_managers: string[] = []
    should_send_invoice_summary_to_billing_team: string[] = []
    should_include_late_fees_in_invoice_summary: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}